import { Leaf, ArrowUp } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

const Footer = () => (
  <footer
    id="contact"
    data-testid="footer"
    className="border-t border-white/8 bg-[#08080a] pt-16"
  >
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid grid-cols-1 gap-12 pb-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <img
            src="/assets/logo.jpg"
            alt="Podi Sambaram — Taste the Tradition"
            className="h-14 w-auto rounded-lg"
          />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-zinc-400">
            Authentic South Indian soul food in the heart of Sohna City.
            Hand-ground podi, pure ghee, and tradition on every plate.
          </p>
          <span className="mt-5 inline-flex items-center gap-2 rounded-full border border-[#388E3C]/40 bg-[#388E3C]/10 px-3.5 py-1.5 font-mono-accent text-[10px] uppercase tracking-widest text-[#4CAF50]">
            <Leaf size={12} /> 100% Pure Vegetarian
          </span>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-mono-accent text-[11px] uppercase tracking-[0.3em] text-[#F57C00]">
            Explore
          </h4>
          <ul className="mt-5 space-y-3">
            {[
              { label: "Our Story", target: "#story", id: "footer-story-link" },
              { label: "Menu", target: "#menu", id: "footer-menu-link" },
              { label: "Gallery", target: "#gallery", id: "footer-gallery-link" },
              { label: "Reserve a Table", target: "#reserve", id: "footer-reserve-link" },
            ].map((l) => (
              <li key={l.target}>
                <button
                  data-testid={l.id}
                  onClick={() => scrollToSection(l.target)}
                  className="text-sm text-zinc-400 transition-colors hover:text-[#FF9800]"
                >
                  {l.label}
                </button>
              </li>
            ))}
            <li>
              <a
                data-testid="footer-track-link"
                href="/track"
                className="text-sm text-zinc-400 transition-colors hover:text-[#FF9800]"
              >
                Track Order
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-mono-accent text-[11px] uppercase tracking-[0.3em] text-[#F57C00]">
            Visit Us
          </h4>
          <p className="mt-5 text-sm leading-relaxed text-zinc-400">
            Shop No. 14, Commercial Block, Global City Center, Global Heights,
            Sector 33, Sohna, Gurugram, Haryana 122103
          </p>
          <p className="mt-3 font-mono-accent text-sm text-zinc-300">+91 92176 12215</p>
          <p className="mt-1.5 font-mono-accent text-sm text-[#FFB74D]">
            8:00 AM – 10:30 PM, All Days
          </p>
          <p className="mt-1.5 text-xs text-[#4CAF50]">
            Free home delivery up to 3 KM • Min. order ₹300
          </p>
          <p className="mt-3 text-xs text-zinc-600">FSSAI Lic. No. 20826005006580</p>
        </div>
      </div>

      <div className="flex flex-col items-center justify-between gap-4 border-t border-white/8 py-6 sm:flex-row">
        <p className="text-xs text-zinc-600">
          © 2026 Podi Sambaram. Taste the Tradition.
        </p>
        <div className="flex items-center gap-4">
          <a
            data-testid="footer-admin-link"
            href="/admin"
            className="text-xs text-zinc-600 transition-colors hover:text-[#FF9800]"
          >
            Staff Login
          </a>
          <button
            data-testid="back-to-top-button"
            onClick={() => scrollToSection("#home")}
            className="flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-xs text-zinc-400 transition-all duration-300 hover:border-[#F57C00]/50 hover:text-[#FF9800]"
          >
            Back to top <ArrowUp size={13} />
          </button>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
